import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface PaymentConfirmationDialogData {
  previousTotalFare: number;
  newTotalFare: number;
  adxBookingId: number;
  adxInvoiceId: number;
}

export interface PaymentConfirmationDialogResult {
  createVendorPayment: boolean;
  createClientPayment: boolean;
}

@Component({
    selector: 'app-create-payment-confirmation-dialog',
    templateUrl: './create-payment-confirmation-dialog.component.html',
    standalone: false
})
export class CreatePaymentConfirmationDialogComponent {
  
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CreatePaymentConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaymentConfirmationDialogData,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      createVendorPayment: [null, Validators.required],
      createClientPayment: [null, Validators.required]
    });
  }

  get fareChange(): number {
    return this.data.newTotalFare - this.data.previousTotalFare;
  }

  confirm(): void {
    const result: PaymentConfirmationDialogResult = {
      createVendorPayment: this.form.value.createVendorPayment === 'yes',
      createClientPayment: this.form.value.createClientPayment === 'yes',
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
